import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface ProductDescriptionProps {
  description: string;
  className?: string;
}

export function ProductDescription({ description, className = '' }: ProductDescriptionProps) {
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const MAX_HEIGHT = 150; // pixels

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.scrollHeight;
      setShowToggle(contentHeight > MAX_HEIGHT);
    }
  }, [description]);

  return (
    <div className={`product-description ${className}`}>
      <div
        ref={contentRef}
        className="desc-content transition-all duration-300 ease-in-out"
        style={{
          maxHeight: expanded ? 'none' : `${MAX_HEIGHT}px`,
          overflow: 'hidden',
          position: 'relative'
        }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
      
      {/* Gradient fade effect when collapsed */}
      {!expanded && showToggle && (
        <div 
          className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent pointer-events-none"
          style={{ marginTop: '-2rem' }}
        />
      )}

      {showToggle && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="toggle-btn flex items-center mt-2 text-blue-600 hover:text-blue-800 transition-colors duration-200 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded px-1 py-1"
          aria-expanded={expanded}
          aria-label={expanded ? 'Show less description' : 'Show more description'}
        >
          {expanded ? (
            <>
              Show Less
              <ChevronUp className="w-4 h-4 ml-1" />
            </>
          ) : (
            <>
              Show More
              <ChevronDown className="w-4 h-4 ml-1" />
            </>
          )}
        </button>
      )}
    </div>
  );
}